/* eslint-disable jsx-a11y/iframe-has-title */
// FIXME https://hellogetsafe.atlassian.net/browse/IA-1344
import { useMemo } from 'react'
import { z } from 'zod'

import { SCREEN_SIZE } from '@nxt-insurance/ui-kit/constants'

import { dimension } from '@/cms/helperTypes'
import { useWindowWidth } from '@/hooks/useWindowWidth'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const iframe = z.object({
  _key: z.string(),
  _type: z.literal('iframe'),
  url: z.string(),
  heightForBigScreens: dimension,
  heightForSmallScreens: dimension,
})

export const Iframe = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = iframe.parse(props.node.value)
  const windowWidth = useWindowWidth()

  const height = useMemo(() => {
    if (windowWidth < SCREEN_SIZE.M) {
      return `${value.heightForSmallScreens.size}${value.heightForSmallScreens.scale}`
    }
    return `${value.heightForBigScreens.size}${value.heightForBigScreens.scale}`
  }, [windowWidth, value])

  return (
    <iframe
      src={value.url}
      className="w-full"
      style={{
        height,
      }}
    />
  )
}
